"use client";

import { useHydrateAtoms } from "jotai/utils";

import {
  isAutoPauseEnabledAtom,
  isMiniPlayerHiddenAtom,
  isShowKnownLemmasEnabledAtom,
} from "../state";

export function VideoControlsProvider({
  initialIsAutoPauseEnabled,
  initialIsShowKnownLemmasEnabled,
  initialIsMiniPlayerHidden,
  children,
}: {
  initialIsAutoPauseEnabled: boolean;
  initialIsShowKnownLemmasEnabled: boolean;
  initialIsMiniPlayerHidden: boolean;
  children: React.ReactNode;
}) {
  useHydrateAtoms([
    [isAutoPauseEnabledAtom, initialIsAutoPauseEnabled],
    [isShowKnownLemmasEnabledAtom, initialIsShowKnownLemmasEnabled],
    [isMiniPlayerHiddenAtom, initialIsMiniPlayerHidden],
  ]);

  return children;
}
